import { useQuery } from "@apollo/client";
import Errors from "components/base/Errors";
import Spinner from "components/base/Spinner";
import { useParams } from "react-router-dom";
import { FETCH_PROJECT } from "./graphql";
import ProjectForm from "./ProjectForm";

const ProjectDetail = () => {
  const { id } = useParams();

  const { loading, error, data } = useQuery(FETCH_PROJECT, {
    variables: { id },
  });

  if (loading) return <Spinner />;
  if (error) return <Errors error={error} />;

  return (
    <ProjectForm
      originalProject={data.project}
      originalProjectData={JSON.parse(data.project.data)}
    />
  );
};

export default ProjectDetail;
